import type {
  FundCommandSelection,
  PartitionCommandSelection,
} from '@festina/unitlink-general-types/unitlink'

export const updatePartitionCommandSelections = (
  updatedPartition: PartitionCommandSelection,
  partitions: PartitionCommandSelection[],
) => {
  const isUpdate = !!partitions.find(
    (selection) => selection?.profileType === updatedPartition.profileType,
  )
  return isUpdate
    ? partitions.map((partition) =>
        partition?.profileType === updatedPartition.profileType
          ? { ...partition, ...updatedPartition }
          : partition,
      )
    : [...partitions, updatedPartition]
}

export const updateFundCommandSelections = (
  updatedFund: FundCommandSelection,
  existingFunds: FundCommandSelection[],
): FundCommandSelection[] => {
  const isUpdate = !!existingFunds.find(
    (selection) => selection?.isinKey === updatedFund.isinKey,
  )

  return isUpdate
    ? existingFunds.map((selection) =>
        selection?.isinKey === updatedFund.isinKey ? updatedFund : selection,
      )
    : [...existingFunds, updatedFund]
}
